import React from 'react';
import { Ticket } from '../types/ticket';
import './SuccessPopup.css';

interface SuccessPopupProps {
  ticket: Ticket;
  onClose: () => void;
  checkInTime: string;
  checkInCount: number;
}

const SuccessPopup: React.FC<SuccessPopupProps> = ({ 
  ticket, 
  onClose, 
  checkInTime, 
  checkInCount 
}) => {
  const normalizeTicketTier = (hangVe: string): string => {
    if (hangVe?.toLowerCase().includes('vé tặng')) {
      return 'BASIC';
    }
    return hangVe;
  };

  const getTicketTierStyle = (hangVe: string) => {
    const normalizedTier = normalizeTicketTier(hangVe).toLowerCase();
    switch (normalizedTier) {
      case 'diamond':
        return {
          background: 'linear-gradient(45deg, #3b82f6, #1d4ed8)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        };
      case 'gold':
        return {
          background: 'linear-gradient(45deg, #f59e0b, #d97706)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        };
      case 'silver':
        return {
          background: 'linear-gradient(45deg, #6b7280, #4b5563)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        };
      case 'basic':
        return {
          background: 'linear-gradient(45deg, #b45309, #92400e)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        };
      default:
        return {
          background: 'linear-gradient(45deg, #3b82f6, #1d4ed8)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        };
    }
  };

  return (
    <div className="success-popup-overlay" onClick={onClose}>
      <div className="success-popup" onClick={(e) => e.stopPropagation()}>
        {/* Close button */}
        <button className="success-popup-close" onClick={onClose}>
          <span className="close-icon">×</span>
        </button>

        {/* Header */}
        <div className="success-popup-header">
          <div className="success-title">CHECK-IN THÀNH CÔNG!</div>
          <div 
            className="ticket-tier-title"
            style={getTicketTierStyle(ticket.hangVe || '')}
          >
            VÉ {normalizeTicketTier(ticket.hangVe || '').toUpperCase()}
          </div>
        </div>

        {/* Ticket Details */}
        <div className="success-popup-content">
          <div className="ticket-detail-row">
            <span className="detail-label">HỌ TÊN</span>
            <span className="detail-value">{ticket.hoTen}</span>
          </div>
          
          <div className="ticket-detail-row">
            <span className="detail-label">ĐIỆN THOẠI</span>
            <span className="detail-value">{ticket.sdt}</span>
          </div>
          
          <div className="ticket-detail-row">
            <span className="detail-label">EMAIL</span>
            <span className="detail-value">{ticket.email}</span>
          </div>
          
          <div className="ticket-detail-row">
            <span className="detail-label">MÃ VÉ</span>
            <span className="detail-value ticket-code">{ticket.maCheckin}</span>
          </div>
          
          <div className="ticket-detail-row">
            <span className="detail-label">SỐ LẦN CHECK-IN</span>
            <span className="detail-value checkin-count">{checkInCount}</span>
          </div>
          
          <div className="ticket-detail-row">
            <span className="detail-label">THỜI GIAN CHECK-IN</span>
            <span className="detail-value checkin-time">{checkInTime}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessPopup;
